var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"10.5","y":"1","width":"3","height":"17","rx":"1.5"}}),_vm._v(" "),_c('rect',{attrs:{"x":"10.5","y":"20","width":"3","height":"3","rx":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }